import { cloneElement, useMemo } from 'react';
import { GoEye, GoEyeClosed } from 'react-icons/go';

export function ShowPasswordToggle({ value, onChange }: { value: boolean; onChange: (value: boolean) => void }) {
  const element = useMemo(() => (value ? <GoEye /> : <GoEyeClosed />), [value]);
  const render = useMemo(
    () => cloneElement(element, { onClick: () => onChange(!value), cursor: 'pointer', fontSize: '26px' }),
    [element, onChange, value]
  );

  return render;
}
